import { useCallback, memo } from 'react'

import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import Button from '@space-lib/components/button'
import Icon from '@space-lib/components/icon'
import Modal from '@space-lib/components/modal'
import ModalBody from '@space-lib/components/modalBody'
import ModalHeader from '@space-lib/components/modalHeader'
import useTranslation from '@space-lib/hooks/useTranslation'
import styled from 'styled-components'

import ContainerUnbanMember from './components/containerUnbanMember'

export type GroupOnSubmitProps = {
  inputValue: string
  groupId: number
}

export type UnbanMemberCommunityModalProps = {
  isOpen: boolean
  closeModal: () => void
}

const CustomModal = styled(Modal)`
  --modal-max-width: 40rem;
`

const paddingModalStyle = '_px-5 _py-4'

const UnbanMemberCommunityModal = ({ isOpen, closeModal }: UnbanMemberCommunityModalProps) => {
  const { t } = useTranslation()

  const handleClose = useCallback(() => {
    closeModal()
  }, [closeModal])

  return (
    <CustomModal show={isOpen} onClose={handleClose}>
      <ModalHeader className='_px-5 _pt-5 _pb-0 '>
        <div className='_pb-1 _d-flex _justify-content-between _align-items-center'>
          <h2 className='_m-0 _text-4 _text-gray-700 _mb-0'>{t('modal.ban_list.title')}</h2>
          <Button variation='tertiary' className='_p-0 _d-flex _border-0' onClick={handleClose}>
            <span className='_sr-only'>close</span>
            <Icon icon={faXmark} className='_w-5 _h-5' size='2x' />
          </Button>
        </div>
      </ModalHeader>

      <ModalBody className={paddingModalStyle}>
        <div className='_d-flex _flex-column _justify-content-center _align-items-start _mb-4'>
          <h3 className='_text-2 _text-gray-900 _font-weight-bold _mb-0'>
            {t('modal.ban_list.sub_title')}
          </h3>

          <p className='_mt-1 _text-2 _text-gray-500'>{t('modal.ban_list.description')} </p>

          <ContainerUnbanMember />
        </div>
      </ModalBody>
    </CustomModal>
  )
}

export default memo(UnbanMemberCommunityModal)
